module.exports = __webpack_public_path__ + "b8d47c51ba544d7f320e87994cc7b9c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iconos-bg.png
// module id = 587
// module chunks = 0